import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { normalizeRole } from "../../../utils/roles";
import { mediaUrl } from "../../../utils/clientHeroTheme";
import md from "../common/manageDesktop.module.css";
import { Avatar, Button, Field, Input } from "../../ui";
import { TRIAL_DAYS } from "../../../constants/trial";
import {
  AdminPushBlock,
  BillingDetailsCard,
  ROLE_LABEL,
  formatDateRu,
  formatRub,
} from "./staffProfileShared";
import { useOwnerProfileForm } from "./ownerProfileForm";

function ProfileFact({ label, value, mono = false }) {
  if (!value) return null;
  return (
    <>
      <dt className={md.desktopOwnerProfileFactLabel}>{label}</dt>
      <dd
        className={
          mono
            ? `${md.desktopOwnerProfileFactValue} ${md.desktopOwnerProfileFactMono}`
            : md.desktopOwnerProfileFactValue
        }
      >
        {value}
      </dd>
    </>
  );
}

export default function AdminOwnerProfileDesktop() {
  const navigate = useNavigate();
  const { role, tenant } = useSelector((state) => state.auth);
  const {
    profile,
    form,
    setForm,
    pwd,
    setPwd,
    billing,
    saving,
    pwdSaving,
    payBusy,
    saveProfile,
    savePassword,
    paySubscription,
  } = useOwnerProfileForm();

  const photoSrc = mediaUrl(profile?.photo_url);
  const roleLabel = ROLE_LABEL[normalizeRole(role)] || role;

  return (
    <div className={md.desktopOwnerProfilePage}>
      <div className={md.desktopOwnerProfileLayout}>
        <aside className={md.desktopOwnerProfileAside}>
          <section className={md.desktopOwnerProfileIdentity}>
            <Avatar
              name={profile?.full_name || "?"}
              src={photoSrc}
              size="lg"
              className={md.desktopOwnerProfileAvatar}
            />
            <h2 className={md.desktopOwnerProfileName}>
              {profile?.full_name || "—"}
            </h2>
            <span className={md.desktopOwnerProfileRole}>{roleLabel}</span>
          </section>

          <dl className={md.desktopOwnerProfileFacts}>
            <ProfileFact label="Email" value={profile?.email} />
            <ProfileFact label="Телефон" value={form.phone || profile?.phone} />
            <ProfileFact label="Клуб" value={tenant?.name} />
            <ProfileFact label="Поддомен" value={billing?.subdomain} mono />
            {billing?.paid_until ? (
              <ProfileFact
                label="Подписка до"
                value={formatDateRu(billing.paid_until)}
              />
            ) : null}
          </dl>

          <button
            type="button"
            className={md.desktopOwnerProfileAsideLink}
            onClick={() => navigate("/manage/app/settings")}
          >
            <span className={md.desktopOwnerProfileAsideLinkText}>
              <strong>Настройки клуба</strong>
              <span>Портал, брендинг, импорт</span>
            </span>
            <span className={md.desktopProfileMenuChevron} aria-hidden />
          </button>
        </aside>

        <div className={md.desktopOwnerProfileMain}>
          {billing ? (
            <section className={md.desktopOwnerProfileSection}>
              <h3 className={md.desktopOwnerProfileSectionTitle}>
                Подписка CRM
              </h3>
              <BillingDetailsCard
                billing={billing}
                payBusy={payBusy}
                onPay={paySubscription}
                trialDays={TRIAL_DAYS}
                formatRub={formatRub}
                formatDateRu={formatDateRu}
              />
            </section>
          ) : null}

          <section className={md.desktopOwnerProfileSection}>
            <h3 className={md.desktopOwnerProfileSectionTitle}>Мои данные</h3>
            <div className={md.desktopOwnerProfileFormGrid}>
              <Field label="Имя">
                <Input
                  value={form.full_name}
                  onChange={(e) =>
                    setForm({ ...form, full_name: e.target.value })
                  }
                />
              </Field>
              <Field label="Телефон">
                <Input
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                />
              </Field>
              <Field label="Email">
                <Input value={profile?.email || ""} readOnly />
              </Field>
            </div>
            <div className={md.desktopOwnerProfileFormActions}>
              <Button type="button" onClick={saveProfile} disabled={saving}>
                {saving ? "Сохранение…" : "Сохранить"}
              </Button>
            </div>
          </section>

          <section className={md.desktopOwnerProfileSection}>
            <h3 className={md.desktopOwnerProfileSectionTitle}>
              Уведомления
            </h3>
            <AdminPushBlock />
          </section>

          <section className={md.desktopOwnerProfileSection}>
            <h3 className={md.desktopOwnerProfileSectionTitle}>Пароль</h3>
            <div className={md.desktopOwnerProfileFormGrid}>
              <Field label="Текущий пароль">
                <Input
                  type="password"
                  value={pwd.current}
                  onChange={(e) =>
                    setPwd({ ...pwd, current: e.target.value })
                  }
                />
              </Field>
              <Field label="Новый пароль">
                <Input
                  type="password"
                  value={pwd.next}
                  onChange={(e) => setPwd({ ...pwd, next: e.target.value })}
                />
              </Field>
            </div>
            <div className={md.desktopOwnerProfileFormActions}>
              <Button
                type="button"
                onClick={savePassword}
                disabled={pwdSaving}
                variant="secondary"
              >
                {pwdSaving ? "…" : "Сменить пароль"}
              </Button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
